import { isPlainObject } from './object';

export const removeItem = (array, element, key, value) => {
  const clonedArray = deepCloneArray(array);
  let idx = clonedArray.indexOf(element);
  if (isPlainObject(element)) {
    idx = array.map(object => object[key]).indexOf(value);
  }
  if (idx > -1) {
    clonedArray.splice(idx, 1);
  }
  return clonedArray;
};

export const deepCloneArray = array => {
  return JSON.parse(JSON.stringify(array));
};

export const compareBy = key => {
  var sortOrder = 1;
  if (key[0] === '-') {
    sortOrder = -1;
    key = key.substr(1);
  }
  return function (a, b) {
    var result = a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
    return result * sortOrder;
  };
};

export const findIndexOfObjectInArray = (arr, key) => {
  let idx = -1;
  arr.forEach((object, i) => {
    const test = Object.keys(object)[0];
    if (test === key) {
      idx = i;
    }
  });
  return idx;
};
